// @flow

export * from './checkbox';
import Checkbox from './checkbox';
import { default as CheckboxTemplate } from './templates/index.html';

export const COMPONENTS_CHECKBOX_NAME = 'checkbox';

export const COMPONENTS_CHECKBOX_ENTITIES = [
	{
		name: COMPONENTS_CHECKBOX_NAME,
		entity: Checkbox,
		template: CheckboxTemplate,
	},
];
